<template>
  <router-view
    v-slot="{ Component }"
  >
    <component
      :is="Component"
      @loading="$emit('loading', $event)"
    />
  </router-view>
</template>

<script>
export default {
  name: 'payins-layout',
  inheritAttrs: false,
  emits: ['loading']
};
</script>
